import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, checkIfNotEmpty } from '../lib/ep';

import LeveledHTMLText from '../components/front/helpers/LeveledHTMLText';
import SaveButton from '../components/builder/SaveButton';

const Wrapper = (props) => {
	const image = props?.image ?? false;
	const description = props?.description ?? false;

	return (
		<div class="flex_cols">
			{(image !== false) && (
				<div class="flex_col col_1">
					<div class="register_media_flex">
						<img src={image} style={{maxWidth:'100%'}} />
					</div>
				</div>
			)}

			<div class="flex_col col_2">
				<div class="register_form_flex" style={{width:'100%'}}>
					{(description !== false && description != "") && (
						<LeveledHTMLText
							_class={{ other:'gui_main_text_color_on_bg' }}
						>{description}</LeveledHTMLText>
					)}

					<div>
						{props.children}
					</div>
				</div>
			</div>
		</div>
	)
};

const ClaimPrizeAttachment = (props) => {
	const prize = props?.prize ?? false;
	const promotion = props?.promotion?.Promotion ?? false;

	if(prize === false || promotion === false) return null;

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const prize_type = prize?.PrizeType ?? {};
	const user = prize?.User ?? {};
	
	//const prize_typ
	const claim_image = (checkIfNotEmpty(promotion?.full_claim_image ?? "")) ? promotion.full_claim_image : false;
	const claim_description = `<h1><strong>${prize_type.title}</strong></h1></p>`;

	const download = (cb) => {
		const queryString = window.location.search;
		$.post(window.location.href, { action:'download' }, (result) => {
			window.location.href = result.url;
			if(cb != undefined) cb();
		}, 'JSON');
	}

	return (
		<Wrapper description={claim_description} image={claim_image}>
			<article class="template_submodule mod_align_center call_to_action_flex enter_flexwrap">
				<div class="enter flex_button gui_big_button register_flex">
					<SaveButton
						_fullclass=""
						icon='knk-download'
						onClick={(e, cb) => download(cb)}
					>Download</SaveButton>
				</div>
			</article>
		</Wrapper>
	)
};

export default injectIntl(ClaimPrizeAttachment);